export default __webpack_public_path__ + "static/media/J_Jacare.d95d6964.svg";